"use client";
import React from "react";
import Header from "./Header/header";
import BottomBar from "./Header/bottombar";
import { usePathname, useSearchParams } from "next/navigation";

const HeaderWrapper = ({ data }) => {
  const path = usePathname();
  const searchParams = useSearchParams();
  const isApplication = searchParams.get("is_application") === "true";

  if (path === "/bas-amasta-j" || isApplication) return null;

  return (
    <>
      <Header data={data} />
      <BottomBar />
    </>
  );
};

export default HeaderWrapper;

